<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .toast-bg{
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.6);
        z-index: 102;
    }
</style>
<template>
    <section class="toast-bg" v-show="status" @click.self="toCancel">
        <img :class="classes" :src="imgs" alt="">
    </section>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
            }
        },
        props: ['code','status','imgs','classes'],
        methods: {
            toCancel: function(){
                this.$parent.$emit('cancel'+this.code);
            },
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
            })
        },
        created() {
            let _this = this,params = []
            let parent = _this.$parent,events = parent[_this.events],code = _this.code
            parent.$on('cancel'+code,(w) => {
                parent.toasts[code] = false;
                params = (events&&events.cancelParam?[events.cancelParam].concat(w):w)
                if(events && events.cancel && _this._checkFun(parent[events.cancel]))
                    parent[events.cancel].apply(this,[params])
            })
        }
    }
</script>


// WEBPACK FOOTER //
// others.vue?1bbf84a6